import React from "react";
import { Table, Skeleton, Row, Pagination } from "antd";
import EditIcon from "../../Icons/EditIcon";
import DeleteIcon from "../../Icons/DeleteIcon";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSendersSearch,
  setPagination,
} from "../../../redux/slices/sendersSearchSlice";

const checkDataValue = (value) => {
  if (!value) {
    return "N/D";
  }
  return value;
};

export default function SendersTable({ sendersDetails, tableActions }) {
  const {
    toggleGenericModal,
    toggleDecisionConfirmationModal,
    getPagedSenders,
  } = tableActions;

  const dispatch = useDispatch();
  const searchParameters = useSelector(selectSendersSearch);

  const { data } = sendersDetails;
  const isLoading =
    sendersDetails?.isLoading || sendersDetails?.status === "loading";
  const showTable = sendersDetails?.searchWasMade === true;

  const columns = [
    {
      title: "Nombre remitente / Empresa",
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      width: "auto",
      align: "center",
    },
    { title: "Dirección", dataIndex: "address", align: "center" },
    {
      title: "CP (Localidad)",
      dataIndex: "postalCode",
      width: "auto",
      align: "center",
      render: (value, row) => (
        <div>
          <span>{row?.postalCode}</span>
          <br />
          <span>({row?.city})</span>
        </div>
      ),
    },
    { title: "País", dataIndex: "country", width: 70, align: "center" },
    { title: "Email", dataIndex: "email", width: "auto", align: "center" },
    {
      title: "Teléfono móvil",
      dataIndex: "mobilePhone",
      width: "auto",
      align: "center",
    },
    {
      title: "NIF/NIE/ Otros",
      dataIndex: "documentId",
      width: "auto",
      align: "center",
      render: (value) => checkDataValue(value),
    },
    {
      title: "Persona de contacto",
      dataIndex: "contactPerson",
      width: "auto",
      align: "center",
      render: (value) => checkDataValue(value),
    },
    {
      title: "Teléfono de contacto",
      dataIndex: "contactPhone",
      width: "auto",
      align: "center",
    },
    {
      title: "Nº Cuenta bancaria",
      dataIndex: "bankAccount",
      width: "auto",
      align: "center",
      render: (value) => checkDataValue(value),
    },
    {
      title: "Acciones",
      width: 90,
      align: "center",
      render: (value, row) => (
        <div className="actions-container">
          <a
            style={{ marginRight: 8 }}
            onClick={() => toggleGenericModal("senderEditForm", row)}
          >
            <EditIcon />
          </a>
          <a onClick={() => toggleDecisionConfirmationModal(row)}>
            <DeleteIcon />
          </a>
        </div>
      ),
    },
  ];

  const handlePageChange = (page, pageSize) => {
    dispatch(setPagination({ page, size: pageSize }));
    getPagedSenders(page, pageSize, searchParameters.participantName, true);
  };

  const handlePageSizeChange = (page, size) => {
    dispatch(setPagination({ page, size }));
    getPagedSenders(page, size, searchParameters.participantName, true);
  };

  const paginatorConfig = {
    position: "top",
    pageSize: searchParameters.size,
    current: searchParameters.page,
    total: sendersDetails?.total,
    onChange: handlePageChange,
    onShowSizeChange: handlePageSizeChange,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `${total} resultados`,
    pageSizeOptions: ["10", "20", "40", "80"],
  };

  if (isLoading) {
    return (
      <div className="SendersTables">
        <Row>
          <div style={{ margin: "16px 0" }}>
            <h2>Resultados</h2>
          </div>
        </Row>
        <Row>
          <Skeleton />
        </Row>
      </div>
    );
  }

  if (showTable && data?.length > 0) {
    return (
      <div className="SendersTables">
        <Row>
          <div style={{ margin: "16px 0" }}>
            <h2>Resultados</h2>
          </div>
          <div className="tracks-table-scroll">
            <Table
              columns={columns}
              dataSource={data}
              bordered
              rowKey={(row) => row?.participantId}
              pagination={false}
              loading={sendersDetails?.isPaginating}
            />
          </div>
        </Row>
        <Row
          type="flex"
          justify="end"
          style={{ marginTop: 16, background: "none", padding: 0 }}
        >
          <Pagination {...paginatorConfig} />
        </Row>
      </div>
    );
  }

  if (showTable && data?.length === 0) {
    return (
      <div className="SendersTables">
        <div style={{ margin: "16px 0" }}>
          <h2>Resultados</h2>
        </div>
        <Row>
          <p>Aún no hay ningún remitente almacenado.</p>
        </Row>
      </div>
    );
  }

  return null;
}
